import React from 'react';
import { Checkbox } from 'primereact/checkbox';
import Colors from '../../utils/colors';

import ClassIcon from '../../assets/icons/exam/class.svg';

interface StepperItemDatamodel {
  itemNumber: number;
  text: string;
  component?: React.ReactNode;
  isSelected: boolean;
}

export const StepperItem: React.FC<StepperItemDatamodel> = ({
  itemNumber,
  text,
  component,
  isSelected,
}) => {
  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        borderRadius: '4px',
        background:
          'linear-gradient(120deg, rgba(96, 165, 250, 0.15), rgba(96, 165, 250, 0.08), rgba(96, 165, 250, 0.12))',
        paddingRight: '8px',
        paddingLeft: '8px',
        paddingTop: '4px',
        paddingBottom: '4px',
      }}
    >
      {/*      <div
        style={{
          height: '32px',
          width: '32px',
          border: '1px solid #f3f4f6',
          borderRadius: '50%',
          color: isSelected ? 'white' : '#4b5563',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: isSelected ? Colors.approveText : '',
        }}
      >
        {itemNumber}
      </div>*/}

      {/*      <img
        style={{
          height: '32px',
          width: '32px',
          border: '1px solid #f3f4f6',
          borderRadius: '50%',
          color: isSelected ? 'white' : '#4b5563',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        src={ClassIcon}
      >
        {itemNumber}
      </img>*/}

      <div
        style={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          borderLeft: '2px solid #ffffff',
          paddingLeft: '4px',
          marginLeft: '4px',
        }}
      >
        <div
          style={{
            height: '32px',
            minHeight: '32px',
            width: '32px',
            minWidth: '32px',
            border: `1px solid ${isSelected ? Colors.approveText : '#6b7280'}`,
            borderRadius: '50%',
            color: isSelected ? 'white' : '#4b5563',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: isSelected ? Colors.approveText : '',
          }}
        >
          {itemNumber}
        </div>
      </div>

      <label
        style={{
          color: '#6b7280',
          fontSize: '16px',
          fontWeight: isSelected ? 'bold' : 'initial',
          direction: 'rtl',
        }}
      >
        {text}
      </label>
      {component}
    </div>
  );
};

interface StepperDataModel {
  items: StepperItemDatamodel[];
}
export const Stepper: React.FC<StepperDataModel> = ({ items }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        direction: 'rtl',
        justifyContent: 'space-between',
        paddingTop: '4px',
        paddingBottom: '4px',
        gap: '16px',
      }}
    >
      {items.map((item) => (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          {/*          <div
            style={{
              height: '32px',
              minHeight: '32px',
              width: '32px',
              border: '1px solid #f3f4f6',
              borderRadius: '50%',
              color: item.isSelected ? 'white' : '#4b5563',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: item.isSelected ? Colors.approveText : '',
            }}
          >
            {item.itemNumber}
          </div>*/}
          <StepperItem
            itemNumber={item.itemNumber}
            text={item.text}
            component={item.component}
            isSelected={item.isSelected}
          />
        </div>
      ))}
    </div>
  );
};
